var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"max-width":"80px","max-height":"80px"}},[(typeof _vm.columnData === 'string')?_c('a',{attrs:{"href":_vm.columnData,"target":"_blank"}},[_c('img',{attrs:{"src":_vm.columnData,"alt":"Image"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }